
import { IdeleteEquipamentoMedicoesUseCase } from "../../../presentation/useCases/delete/delete_equipamento_medicoes_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * deleteEquipamentoMedicoesUseCase
 */

export class deleteEquipamentoMedicoesUseCase implements IdeleteEquipamentoMedicoesUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async deleteEquipamentoMedicoes(id: number): Promise<void> {
    await this.repository.deleteEquipamentoMedicaoById(id);
  }
}
